import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./useAuth";
import type { UserRole } from "@/types";

interface Props {
  children: React.ReactNode;
  requiredRole?: UserRole;
  requiredRoles?: UserRole[];
}

export function ProtectedRoute({ children, requiredRole, requiredRoles }: Props) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface">
        <p className="text-muted-foreground">Caricamento...</p>
      </div>
    );
  }

  if (!user) {
    // return-to: LoginPage rilegge state.from e ci torna dopo il login (deep-link Telegram)
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  // OR logic: user must have at least one of the required roles
  const roles = requiredRoles ?? (requiredRole ? [requiredRole] : []);
  if (roles.length > 0 && !roles.some((r) => user.roles.includes(r))) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
